<!-- <fl-modal [modalTitle]="title" [actions]="modalActions">
  Select a template entity to test. You can add additional variables below.
</fl-modal>
 -->
<header>
  <h1 class="modal-title">Test Data and Variables</h1>
  <button
    (click)="close()"
    aria-label="Close"
    class="modal-close"
    inlineSVG="/assets/icons/close.svg"
  ></button>
</header>

<form>
  <label>
    Select a template to prefill your form.
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-select
        [(ngModel)]="selectedTemplate"
        (selectionChange)="setTemplate($event)"
        name="form"
        panelClass="set-template-form-select"
        placeholder="Select a template"
      >
        <mat-option *ngFor="let template of templates" [value]="template">
          <span>{{ template.label }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </label>

  <section>
    <div class="mock-mat-input options-container">
      <table class="draggable-optionset" style="margin: 0">
        <thead>
          <tr>
            <th>Variable</th>
            <th>Value</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr class="draggable-row" *ngFor="let key of dynamicModelKeys()">
            <!-- Label TD -->
            <td>
              <input
                [value]="key"
                autocapitalize="off"
                autocomplete="off"
                autocorrect="off"
                name="field_option_key"
                spellcheck="false"
                readonly="readonly"
              />
            </td>

            <!-- Value TD -->
            <td>
              <input
                [(ngModel)]="dynamicModels[key]"
                [ngModelOptions]="{ standalone: true }"
                autocapitalize="off"
                autocomplete="off"
                autocorrect="off"
                spellcheck="false"
              />
            </td>

            <td>
              <a class="remove" (click)="removeVariableValue(key)">
                <i class="material-icons">clear</i>
              </a>
            </td>
          </tr>
          <tr class="no-highlight">
            <td>
              <input
                [(ngModel)]="variableValueToAdd.key"
                name="field_option_to_add_key"
                placeholder="New Label"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
              />
            </td>
            <td>
              <input
                [(ngModel)]="variableValueToAdd.value"
                name="field_option_to_add_value"
                placeholder="New Value"
                autocomplete="off"
                autocorrect="off"
                autocapitalize="off"
                spellcheck="false"
              />
            </td>
            <td>
              <a class="add" (click)="addNewVariableValue()">
                <i class="material-icons">add_circle</i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <div class="modal-buttons">
    <button (click)="close()" type="button">Cancel</button>
    <button (click)="applyDynamicModels()" type="button">Apply</button>
  </div>
</form>
